export default __webpack_public_path__ + "static/media/DeadWooding.d515b8db.JPG";